import { useEffect, useState } from 'react';
import { listSpaces, type MeResponse } from '../api/auth';
import { getTask } from '../api/tasks';
import { spaceForTaskLink } from './task-deep-link';

// Older Mattermost messages point at login.* rather than a Space host. Resolve
// the task before switching hosts, so a user with multiple Spaces lands on the
// actual detail instead of the Space picker or their last-used Space.
export function TaskDeepLinkRedirect({
  taskId,
  me,
  baseHost,
  portSuffix,
  protocol,
}: {
  taskId: number;
  me: MeResponse;
  baseHost: string;
  portSuffix: string;
  protocol: string;
}) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([getTask(taskId), listSpaces()])
      .then(([task, spaces]) => {
        if (cancelled) return;
        const space = spaceForTaskLink(task.primarySpaceId, me.activeSpaceId, spaces);
        if (!space?.subdomain || !baseHost) {
          setError('Nemáš dostupný Space, ve kterém lze úkol otevřít.');
          return;
        }
        window.location.replace(`${protocol}//${space.subdomain}.${baseHost}${portSuffix}/ukoly?taskId=${taskId}`);
      })
      .catch(() => {
        if (!cancelled) setError('Úkol se nepodařilo načíst. Ověř, že k němu máš přístup.');
      });
    return () => { cancelled = true; };
  }, [taskId, me.activeSpaceId, baseHost, portSuffix, protocol]);

  return (
    <main className="loading-screen">
      {error ? (
        <>
          <h1>Úkol nelze otevřít</h1>
          <p>{error}</p>
          <a href="/">Přejít na výběr Space</a>
        </>
      ) : <p>Otevírám úkol…</p>}
    </main>
  );
}
